import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MoonIcon, SunIcon } from 'lucide-react';
import { twMerge } from 'tailwind-merge';
import { useTheme } from '../../contexts/ThemeContext';
import { spring } from '../../utils/motion';
export function ThemeToggle({
  className
}: {
  className?: string;
}) {
  const {
    resolved,
    toggle
  } = useTheme();
  const dark = resolved === 'dark';
  return <motion.button type="button" onClick={toggle} whileTap={{
    scale: 0.9
  }} transition={spring.snappy} aria-label={dark ? 'Switch to light mode' : 'Switch to dark mode'} className={twMerge('relative grid h-10 w-10 place-items-center overflow-hidden rounded-full text-ink-2 transition-colors duration-150 hover:bg-surface-2 hover:text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand', className)} data-id="element-845" data-mp="18u450cpdnnoq">
      <AnimatePresence mode="popLayout" initial={false} data-id="element-846" data-mp="l386kwqf1u8i">
        <motion.span key={dark ? 'moon' : 'sun'} initial={{
        opacity: 0,
        rotate: -60,
        scale: 0.6
      }} animate={{
        opacity: 1,
        rotate: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        rotate: 60,
        scale: 0.6
      }} transition={spring.bouncy} className="grid place-items-center" data-id="element-847" data-mp="l5udqv9ea7q7">
          {dark ? <MoonIcon className="h-5 w-5" data-id="element-848" data-mp="3ke29zq734ind" /> : <SunIcon className="h-5 w-5" data-id="element-849" data-mp="3kf3ns2fhjj8s" />}
        </motion.span>
      </AnimatePresence>
    </motion.button>;
}